module.exports = __webpack_public_path__ + "img/closed.b827bdd5.svg";